module.exports = __webpack_public_path__ + "static/media/5.c8e0d133.png";